<template>
  <div class="userStatistics">
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="创建时间">
          <el-date-picker
            unlink-panels
            :clearable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="bedata"
            @change="timechange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="primary" @click="exportStreet"
            >导出街道数据</el-button
          >
          <el-button type="primary" @click="exportComunity()"
            >导出社区数据</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="statistics">
      <div>
        <p>{{ summaryList.newUser || "--" }}</p>
        <p>新增用户</p>
      </div>
      <div>
        <p>{{ summaryList.rebycleUser || "--" }}</p>
        <p>可回收首投人数</p>
      </div>
    </div>
    <div class="table_div">
      <el-table
        :data="userStatisticsList"
        border
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        :default-expand-all="false"
        ref="tables"
        style="width: 100%"
      >
        <el-table-column type="expand" width="1">
          <template slot-scope="scope">
            <p class="tip" v-show="scope.row.children.length == 0">暂无内容</p>
            <el-table
              v-show="scope.row.children.length > 0"
              border
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              :data="scope.row.children"
              style="
                width: 100%;
                margin-top: 20px;
                margin-bottom: 50px;
                border: 1px solid #ccc;
              "
            >
              <el-table-column type="index"></el-table-column>
              <el-table-column prop="name" label="社区名称"></el-table-column>
              <el-table-column
                prop="newPeople"
                label="新增人数"
              ></el-table-column>
              <el-table-column
                prop="participateUserNum"
                label="参与户数"
              ></el-table-column>
              <el-table-column
                prop="participateUserRate"
                label="参与率(%)"
              ></el-table-column>
              <el-table-column
                prop="recycledNum"
                label="可回收数量"
              ></el-table-column>
              <el-table-column
                prop="registerUserNum"
                label="注册户数"
              ></el-table-column>
              <el-table-column
                prop="registerUserRate"
                label="注册比"
              ></el-table-column>
              <el-table-column prop="userNum" label="用户数"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="街道名称"></el-table-column>
        <el-table-column prop="newPeople" label="新增人数"></el-table-column>
        <el-table-column
          prop="participateUserNum"
          label="参与户数"
        ></el-table-column>
        <el-table-column
          prop="participateUserRate"
          label="参与率(%)"
        ></el-table-column>
        <el-table-column
          prop="recycledNum"
          label="可回收数量"
        ></el-table-column>
        <el-table-column
          prop="registerUserNum"
          label="注册户数"
        ></el-table-column>
        <el-table-column
          prop="registerUserRate"
          label="注册比"
        ></el-table-column>
        <el-table-column prop="userNum" label="用户数"></el-table-column>
        <el-table-column width="150px" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-show="scope.row.isopen"
              size="mini"
              @click="open(scope.row)"
              >展开下级社区</el-button
            >
            <el-button
              v-show="!scope.row.isopen"
              size="mini"
              @click="close(scope.row)"
              >合上下级社区</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  registerstreetList,
  communityList,
  streetListSummary,
} from "@/api/management";
import { publicMixin } from "@/mixins/publicMixin";
import { getLast7Days } from '@/utils/util';
export default {
  name: "userStatistics",
  mixins: [publicMixin],
  data() {
    return {
      bedata: "",
      summaryList: {},
      queryParam: {
        beginTime: "",
        endTime: "",
      },
      userStatisticsList: [],
    };
  },
  created() {
    // var myDate = new Date();
    // // 获取 特定日期 之前的 第七天
    // let tmpArr = [];
    // tmpArr.push(
    //   moment(myDate.setDate(myDate.getDate() - 7)).format("YYYY-MM-DD HH:mm:ss")
    // );
    // tmpArr.push(moment(new Date().valueOf()).format("YYYY-MM-DD HH:mm:ss"));
    // this.bedata = tmpArr;
    // this.queryParam.beginTime = this.bedata[0];
    // this.queryParam.endTime = this.bedata[1];
    this.bedata = getLast7Days();
    this.timechange(this.bedata);
    this.searchQuery();
  },
  methods: {
    close(row) {
      this.$refs.tables.toggleRowExpansion(row);
      row.isopen = true;
    },
    open(row) {
      console.log(row);
      let obj = {};
      obj = JSON.parse(JSON.stringify(this.queryParam));
      obj.streetId = row.id;
      communityList(obj).then((res) => {
        if (res.code == 200) {
          this.userStatisticsList.forEach((item) => {
            if (item.id == row.id) {
              row.isopen = false;
              item.children = res.data;
              this.$refs.tables.toggleRowExpansion(row);
            }
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    exportStreet() {
      let exportXlsUrl = "community/statistical/register/streetList/export";
      let fileName = "街道数据";
      let obj = {};
      obj = JSON.parse(JSON.stringify(this.queryParam));
      obj.pageNo = this.currentPage;
      obj.pageSize = this.PageSize;
      this.export(exportXlsUrl, obj, fileName);
    },
    exportComunity(row) {
      let exportXlsUrl = "community/statistical/register/communityList/export";
      let fileName = `社区数据`;
      let obj = {};
      obj = JSON.parse(JSON.stringify(this.queryParam));
      obj.streetId = "";
      this.export(exportXlsUrl, obj, fileName);
    },
    searchQuery() {
      this.currentPage = 1;
      this.getDataList();
      this.getstreetListSummary();
    },
    timechange(val) {
      console.log(val);
      this.queryParam.beginTime = val[0];
      this.queryParam.endTime = val[1];
    },
    getstreetListSummary() {
      let obj = {};
      obj = JSON.parse(JSON.stringify(this.queryParam));
      streetListSummary(obj).then((res) => {
        if (res.code == 200) {
          this.summaryList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getDataList() {
      let obj = {};
      obj = JSON.parse(JSON.stringify(this.queryParam));
      obj.pageNo = this.currentPage;
      obj.pageSize = this.PageSize;
      registerstreetList(obj).then((res) => {
        if (res.code == 200) {
          this.totalCount = res.data.total;
          this.currentPage = res.data.current;
          this.PageSize = res.data.size;
          this.userStatisticsList = res.data.records;
          this.userStatisticsList.forEach((item) => {
            item.children = [];
            item.isopen = true;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table__row {
  .el-table__expand-icon > .el-icon {
    display: none;
  }
}
.userStatistics {
  padding: 18px;
  .search_wrap {
    margin-top: 20px;
  }
  .statistics {
    font-size: 14px;
    width: 260px;
    display: flex;
    justify-content: space-between;
    div {
      width: 120px;
      border-radius: 12px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  .table_div {
    margin-top: 20px;
    .tip {
      text-align: center;
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
